/** Presentation categories for canonical parser output; never converts evidence kinds or creates edges. */
export type ForensicRecordCategory = "processes" | "network" | "files";
export function forensicRecordCategory(kind: string, payload: Record<string, unknown>): ForensicRecordCategory | null {
  if (kind === "entity") {
    const type = String(payload.entity_type);
    if (type === "process") return "processes";
    if (["ip_address", "domain", "url", "network_connection", "network_endpoint", "windows.network.ip_address"].includes(type)) return "network";
    if (["file", "file_path"].includes(type)) return "files";
  }
  if (kind !== "observation") return null;
  const type = String(payload.observation_type);
  const families = {
    processes: ["windows.process.metadata", "windows.process_metadata"],
    network: ["windows.network.interface", "windows.network_metadata"],
    files: ["windows.filesystem.metadata", "windows.filesystem_metadata"],
  } as const;
  for (const [category, names] of Object.entries(families)) {
    if (names.some(name => type === name || type.startsWith(`${name}.`))) return category as ForensicRecordCategory;
  }
  // New package generations preserve the exact artifact contract inside observations.
  // Route only recognized contract families, not arbitrary words in a title/path.
  const attributes = payload.attributes;
  if (!attributes || typeof attributes !== "object" || Array.isArray(attributes)) return null;
  const contract = (attributes as Record<string, unknown>).artifact_contract_version;
  if (typeof contract !== "string") return null;
  if (/^windows-process-metadata\.v\d+$/.test(contract)) return "processes";
  if (/^windows-filesystem-metadata\.v\d+$/.test(contract)) return "files";
  if (/^windows-(network-[a-z-]+|dns-cache)-metadata\.v\d+$/.test(contract)) return "network";
  return null;
}
